import { Paper, Typography, Box } from 'src/components';
import Markdown from 'src/pages/handbook/article/markdown';

function TLDR({ children }) {
  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        bgcolor: theme.palette.mode === 'light'
          ? theme.palette.grey[50]
          : theme.palette.grey[900],
        p: { xs: 2, sm: 2.5 },
        mb: 5,
        boxShadow: 'none',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        '&:hover': {
          boxShadow: theme.shadows[1],
          transform: 'translateY(-1px)',
        },
      })}
    >
      <Typography
        variant="body1"
        component="body1"
        sx={{
          fontWeight: 700,
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: 'secondary.main',
        }}
      >
        Summary
      </Typography>
      <Box component="div" sx={{ pl: 0.5 }}>
        <Markdown>{children}</Markdown>
      </Box>
    </Paper>
  );
}

export default TLDR;
